module.exports = __webpack_public_path__ + "img/goldregen-2020-106.826d786a.jpg";